import { useEffect, useState, type InputHTMLAttributes } from 'react';
import { isoToDmy, parseDateInput } from '../dates';

// Tarix sahəsi (KT-95): brauzerin dilindən asılı deyil — həmişə gg.aa.iiii. Dəyər ISO (YYYY-MM-DD) və ya boş.
// type="date" brauzer dilinə görə «mm/dd/yyyy» göstərirdi.
type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> & {
  value: string;
  onChange: (iso: string) => void;
};

export function DateField({ value, onChange, ...rest }: Props) {
  const [text, setText] = useState(isoToDmy(value));
  const [invalid, setInvalid] = useState(false);

  // Kənardan dəyər dəyişəndə (məs. sıfırlama) mətn də yenilənsin
  useEffect(() => {
    setText(isoToDmy(value));
    setInvalid(false);
  }, [value]);

  const commit = (t: string) => {
    if (t.trim() === '') {
      setInvalid(false);
      onChange('');
      return;
    }
    const iso = parseDateInput(t);
    setInvalid(iso === null);
    // Səhv/natamam tarix köhnə dəyəri saxlamasın (hesabat və nisyə səssizcə köhnə tarixlə getməsin)
    onChange(iso ?? '');
  };
  const errId = rest.id ? `${rest.id}-err` : undefined;

  return (
    <>
    <input
      {...rest}
      type="text"
      inputMode="numeric"
      placeholder="gg.aa.iiii"
      autoComplete="off"
      value={text}
      aria-invalid={invalid || undefined}
      aria-describedby={invalid ? errId : undefined}
      onChange={(e) => {
        const v = e.target.value;
        // Yapışdırma: ISO (2026-11-01) və ya ayırıcılı (01/11/2026, 01-11-2026) tarix birbaşa çevrilir
        const pasted = parseDateInput(v);
        if (pasted !== null && /[-/]/.test(v)) {
          setText(isoToDmy(pasted));
          commit(isoToDmy(pasted));
          return;
        }
        // Rəqəm yazılanda nöqtələr avtomatik: 01112026 → 01.11.2026
        const digits = v.replace(/\D/g, '').slice(0, 8);
        const t = v.includes('.') ? v.slice(0, 10) : [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join('.');
        setText(t);
        if (t.length === 10 || t === '') commit(t);
      }}
      onBlur={() => commit(text)}
    />
    {invalid && (
      <span id={errId} className="bad small" role="alert">
        Tarix gg.aa.iiii formatında olmalıdır
      </span>
    )}
    </>
  );
}
